import { Plus } from "lucide-react";
import { Product } from "../../types/product.types";
import { useTranslation } from "react-i18next";

interface ProductCardProps {
  product: Product;
  onAddToCart: (product: Product) => void;
}

export const ProductCard = ({ product, onAddToCart }: ProductCardProps) => {
  const { t } = useTranslation();

  return (
    <div className="bg-popupLight cursor-pointer dark:bg-popupDark rounded-xl shadow-md hover:shadow-xl transition-transform transform hover:-translate-y-1 p-4">
      <img
        src={product?.image}
        alt={product?.name}
        className="w-full h-40 object-cover rounded-lg mb-4"
      />
      <h3 className="text-lg font-semibold text-primaryText dark:text-primaryTextDark mb-1">
        {product?.name}
      </h3>
      <p className="text-sm text-primaryText dark:text-primaryTextDark mb-3 line-clamp-2">
        {product?.description}
      </p>
      <div className="flex items-center justify-between">
        <p className="font-bold text-primaryText dark:text-primaryTextDark">
          ₹{product?.price}
        </p>
        <button
          onClick={() => onAddToCart(product)}
          className="flex items-center gap-1 bg-secondaryText/80 dark:bg-secondaryTextDark/80 text-primaryText text-sm py-1 px-2 rounded-md hover:bg-secondaryText hover:dark:bg-secondaryTextDark transition"
        >
          <Plus className="w-3 h-3" />
          {t("addToCart") || "Add to Cart"}
        </button>
      </div>
    </div>
  );
};
